import axios from "../utils/axios";

export const getFavorites = async (type ='product') => {
    const params = {
        type
    };
    const { data } = await axios.get(`/user/favorites`,{ params });
    return data;
};

// Send Favorites
export const sendFavorites = async (req) => {
    try {
        const { data } = await axios.post('/user/favorites/toggle', req, {
            headers: {
                'Accept': 'application/json',
            },
        });
        return data;
    } catch (error) {
        console.error("🚀 ~ createStore ~ error:", error);
        throw error;
    }
};